module.exports = __webpack_public_path__ + "img/logo.bf82dde3.svg";